"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.comparedVehicleIdsReducer = void 0;
const comparedVehicleIds_1 = require("../actions/comparedVehicleIds");
const REDUCER_UTILS = require("../utils/immutable-reducers");
const initState = [];
const comparedVehicleIdsReducer = (vehicleIdsArray = initState, action) => {
    switch (action === null || action === void 0 ? void 0 : action.type) {
        case comparedVehicleIds_1.ADD_VEHICLE_ID_TO_COMPARE:
            return REDUCER_UTILS.addItemLimiter(vehicleIdsArray, action.payload, 3);
        case comparedVehicleIds_1.REMOVE_VEHICLE_ID_FROM_COMPARE:
            return REDUCER_UTILS.removeItem(vehicleIdsArray, action.payload);
        default:
            return vehicleIdsArray;
    }
};
exports.comparedVehicleIdsReducer = comparedVehicleIdsReducer;
//# sourceMappingURL=comparedVehicleIds.reducer.js.map